import { render, staticRenderFns } from "./top.vue?vue&type=template&id=03ef7446&scoped=true"
import script from "./top.vue?vue&type=script&setup=true&lang=js"
export * from "./top.vue?vue&type=script&setup=true&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=03ef7446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ef7446",
  null
  
)

export default component.exports